import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { required } from '../../util/validators';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import {intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import { findOptionsForSelectFilter } from '../../util/search';
import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, FieldCheckboxGroup, Form, FieldSelect } from '../../components';

import css from './EditListingCarsForm.module.css';

const EditListingCarsFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        disabled,
        ready,
        rootClassName,
        className,
        name,
        handleSubmit,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        filterConfig,
        intl
      } = formRenderProps;

      const classes = classNames(rootClassName || css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = disabled || submitInProgress;

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingCarsForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingCarsForm.showListingFailed" />
        </p>
      ) : null;

      // const accessResetLabel = intl.formatMessage({
      //   id: 'EditListingAccessForm.accessResetLabel',
      // });

      // const accessPeriodLabel = intl.formatMessage({
      //   id: 'EditListingAccessForm.accessPeriodLabel',
      // });

      // const accessRequired = required(
      //   intl.formatMessage({
      //     id: 'EditListingAccessForm.accessRequired',
      //   })
      // );

      const options = findOptionsForSelectFilter('vehicleCompatibility', filterConfig);
      console.log(options)
      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}

          <FieldCheckboxGroup className={css.features} id={name} name={name} options={options} />


<p className={css.notMandatoryWarning}>Ces informations ne sont pas obligatoires, n'hésitez pas à appuyer sur "suivant" si vous ne souhaitez pas les compléter</p>


          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingCarsFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
  filterConfig: config.custom.filters,
};

EditListingCarsFormComponent.propTypes = {
  intl: intlShape.isRequired,
  rootClassName: string,
  className: string,
  name: string.isRequired,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  filterConfig: propTypes.filterConfig,
};

const EditListingCarsForm = EditListingCarsFormComponent;
export default compose(injectIntl)(EditListingCarsForm);

